import React from 'react';
import { Box, CardContent, Typography, useTheme } from '@mui/material';
import Logo from '../Logo/Dark/Full - Copy/1Asset 17@72x-8.png';

const PosterMessage = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #000000, #000000)',
        padding: 2,
      }}
    >
      <Box
        sx={{
          maxWidth: 700,
          width: '100%',
          borderRadius: 3,
          padding: 4,
          backgroundColor: '#000000',
          color: '#ffffff',
          boxShadow: '0 8px 20px rgba(0,0,0,0.5)',
        }}
      >
        <Box sx={{ textAlign: 'center', mt: 10, mb: 2 }}>
          <img
            src={Logo}
            alt="Logo"
            style={{
              width: '100%',
              maxWidth: '350px',
              height: 'auto',
            }}
          />
        </Box>

        <CardContent>

          <Typography
            variant="h5"
            component="h1"
            sx={{
              fontWeight: 500,
              textAlign: 'center',
              fontSize: '2.5rem',
              backgroundImage: "linear-gradient(45deg, #00bfff, #ff00ff)",
              backgroundClip: "text",

              color: 'transparent',
              // color: 'white',
              letterSpacing: 6,

              marginBottom: '40px',

            }}
          >
            Be Part of the Knowledge Revolution!
          </Typography>


          <Typography variant="body1" gutterBottom sx={{ fontSize: '1.1rem', mt: 2, letterSpacing: 1 }}>
            Ready to unlock the power of knowledge and connection? Join the movement with <strong>Anthrasync</strong> — where learning knows no boundaries.
          </Typography>

          <Box sx={{ mt: 2, letterSpacing: 1 }}>
            <Typography variant="body1" gutterBottom>✔ Host sessions and share your expertise with the world.</Typography>
            <Typography variant="body1" gutterBottom>✔ Request sessions and fuel your curiosity with real-time learning.</Typography>
            <Typography variant="body1" gutterBottom>✔ Choose a user and request a session on a topic of your choice.</Typography>
            <Typography variant="body1" gutterBottom>✔ Anytime. Anywhere. In any language.</Typography>
          </Box>

          <Typography variant="body1" sx={{ mt: 3, letterSpacing: 1 }}>
            Step into a future where learning is limitless.<br />
            <strong>Anthrasync — Empowering minds, one session at a time.</strong>
          </Typography>

          <Typography variant="body2" sx={{ mt: 3, fontStyle: 'italic', letterSpacing: 1 }}>
            Regards,<br />
            Team Anthrasync
          </Typography>

          <Box sx={{ mt: 4, display: 'flex', }}>

            <Typography
              variant="body1"
              sx={{
                fontWeight: 500,
                textAlign: 'center',
                fontSize: '1rem',
                backgroundImage: "linear-gradient(45deg, #00bfff, #ff00ff)",
                backgroundClip: "text",

                color: 'transparent',
                letterSpacing: 6,

                marginBottom: '40px',

              }}
            >
                                                                                                       Explore more at --> www.anthrasync.com
            </Typography>




          </Box>


        </CardContent>
      </Box>
    </Box>
  );
};

export default PosterMessage;